'use strict'

import React from 'react';
import Layout from '../Layout.jsx';
import ProjectMenu from '../components/ProjectMenu.jsx';

import {RegisterRelease} from '../NewProject.jsx';

export class ReleaseProperties extends React.Component {
  render() {
    return (
      <div>
        <div style={{textAlign: "center", display:"flex", justifyContent:"center"}}>
          <div style={{width:1016}}>
            <RegisterRelease {...this.props} project={this.props.release}/>
          </div>
        </div>
      </div>
    )
  }
}

export default class ReleasePropertiesPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props} project={this.props.release}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu} project={this.props.release}>
        <ReleaseProperties {...this.props}/>
      </Layout>
    );
  }

}



// WEBPACK FOOTER //
// ./views/product/ReleaseProperties.jsx